import { Textsms } from "./textsms";
import { Theaters } from "./theaters";
import { ThumbsUpDown } from "./thumbs_up_down";
import { Timeline } from "./timeline";
import { TipsAndUpdates } from "./tips_and_updates";
import { Today } from "./today";
import { Tour } from "./tour";
import { Traffic } from "./traffic";
import { TravelExplore } from "./travel_explore";
import { TwoWheeler } from "./two_wheeler";

const iconsList = [
  { label: "Textsms", code: <Textsms /> },
  { label: "Theaters", code: <Theaters /> },
  { label: "ThumbsUpDown", code: <ThumbsUpDown /> },
  { label: "Timeline", code: <Timeline /> },
  { label: "TipsAndUpdates", code: <TipsAndUpdates /> },
  { label: "Today", code: <Today /> },
  { label: "Tour", code: <Tour /> },
  { label: "Traffic", code: <Traffic /> },
  { label: "TravelExplore", code: <TravelExplore /> },
  { label: "TwoWheeler", code: <TwoWheeler /> },
];

export {
  iconsList,
  Textsms,
  Theaters,
  ThumbsUpDown,
  Timeline,
  TipsAndUpdates,
  Today,
  Tour,
  Traffic,
  TravelExplore,
  TwoWheeler,
};
